import { render, staticRenderFns } from "./Medications.vue?vue&type=template&id=f15b1838&scoped=true&"
import script from "./Medications.vue?vue&type=script&lang=js&"
export * from "./Medications.vue?vue&type=script&lang=js&"
import style0 from "./Medications.vue?vue&type=style&index=0&id=f15b1838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15b1838",
  null
  
)

export default component.exports